export const PLAYER_HOST = 'https://case-player-online.nobula.eu';
export const PLAYER_PRES_ID_QUERY = 'presentationId';
export const PLAYER_ROOM_ID_QUERY = 'roomId';
export const ROOM_ADMIN_QUERY = 'roomAdmin';
export const PRESENTER_CODE_QUERY = 'presenterCode';
